var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Field__Component", class: _vm.field.Class },
    [
      _c("div", {
        staticClass: "html-content",
        domProps: { innerHTML: _vm._s(_vm.value) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }